import { colonyAPI } from '@/api';
import * as types from './mutation-types';

export default {
  getProfileFields({ commit }) {
    return colonyAPI
      .get('/construct/profiles/fields/')
      .then(response => commit(types.GET_PROFILE_FIELDS_SUCCESS, response))
      .catch(error => commit(types.GET_PROFILE_FIELDS_FAILURE, error));
  },

  getProfiles({ commit, state }) {
    const payload = { params: { page: state.page } };
    commit(types.GET_PROFILES_REQUEST);

    colonyAPI
      .get('/construct/profiles/query/', payload)
      .then(response => commit(types.GET_PROFILES_SUCCESS, response))
      .catch(error => commit(types.GET_PROFILES_FAILURE, error));
  },

  searchProfiles({ commit, state }, query) {
    const payload = { params: { page: state.page } };
    commit(types.SET_IS_SEARCHING);
    commit(types.GET_PROFILES_REQUEST);
    commit(types.SET_SEARCH_QUERY, query);

    colonyAPI
      .post('/construct/profiles/search/', query, payload)
      .then(response => commit(types.GET_PROFILES_SUCCESS, response))
      .catch(error => commit(types.GET_PROFILES_FAILURE, error));
  },

  loadMoreProfiles({ commit, state, dispatch }) {
    commit(types.SET_PAGE_COUNT, state.page + 1);

    if (state.isSearching && state.searchQuery) {
      dispatch('searchProfiles', state.searchQuery);
    } else {
      dispatch('getProfiles');
    }
  },

  searchProfileForIdentity({ commit, dispatch, state }, [originatorType, originator]) {
    let processedOriginator = originator;
    if (originatorType === 'whatsapp_handle') {
      processedOriginator = `${originator}@s.whatsapp.net`;
    }

    const query = {
      type: 'and',
      query: [
        { field: `identifiers.${originatorType}`, lookup: 'equals', value: processedOriginator },
      ],
    };
    colonyAPI
      .post('/construct/profiles/search/', query)
      .then(response => {
        if (response.data.length) {
          commit(types.GET_PROFILE_IDENTITY_SUCCESS, response.data);
          commit(types.SHOW_PROFILES_DIALOG, true);
        } else {
          dispatch('toast/info', `Profile not yet available for ${originator}`, { root: true });
        }
      })
      .catch(() => {
        commit(types.GET_PROFILE_IDENTITY_FAILURE);
        dispatch('toast/error', `We were unable to get a profile for ${originator}`, {
          root: true,
        });
      });
  },

  updateDemographicFilters({ commit }, { filterKeyValue, val }) {
    commit(types.SET_DEMOGRAPHIC_FILTERS, { filterKeyValue, val });
  },

  updateProfileFilters({ commit }, filters) {
    commit(types.SET_PROFILES_FILTER_FIELDS, filters);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/profile/actions.js